<template>
    <form @submit.prevent="submit">
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ title }}</p>
            </header>
            <section class="modal-card-body">
                <slot></slot>
            </section>
            <footer class="modal-card-foot" v-if="$slots.footer">
                <slot name="footer"></slot>
            </footer>
        </div>
    </form>
</template>

<script>
    export default {
        name: "formModal",
        
        props: {
            title: {
                type: String,
                required: true
            }
        },
        
        methods: {
            submit(){
                this.$emit('submit', this);
            }
        }
    }
</script>
